module.exports = __webpack_public_path__ + "img/logo_szelence.0ec32ae4.png";